var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"button",attrs:{"to":_vm.linkTo}},[(this.icon != '')?_c('i',{class:this.icon}):_vm._e(),_vm._v(" "+_vm._s(this.msg)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }